"use strict";
import ApiService from "@/core/services/api.service";

const baseURL = "Map";

export default {
  getMapPathReportData(payload) {
    return new Promise(resolve => {
      ApiService.get(
        `${baseURL}/GetMapPathReportData`,
        `?vehicleID=${payload.vehicleId}&dtFrom=${payload.fromDateTime}&dtTo=${payload.toDateTime}`
      ).then(({ data }) => resolve(data));
    });
  }
};
